<template>
  <div class="one-column-content">
    <pre-header />
    <slot />
  </div>
</template>

<script>
import PreHeader from './PreHeader'

export default{
  components: {
    PreHeader
  }
}
</script>

<style lang="scss">
@import '../../assets/scss/breakpoint.scss';

/* @group Layout */

.one-column-content{

  $marginLeftRight: 7.5%;
  $marginLeftRightDesktop: 15%;
  $marginBottom: 15%;
  $padding: 10rem;
  $paddingDesktop: 17.5rem;
  $paddingDesktopTop: 30rem;

  .block--header{
    padding: $paddingDesktop $marginLeftRight $padding;
    @include media(">=large"){
      padding: 17.5rem $marginLeftRightDesktop 12.5rem;
    }
    @include media(">=xlarge"){
      padding: 30rem $marginLeftRightDesktop 17.5rem;
    }
  }

  .block--content{
    & > h3, & > h4, & >  p, & > ul, & > .block--schedule{
      margin-left: $marginLeftRight;
      margin-right: $marginLeftRight;
      &:first-of-type{
        margin-top: 0;
      }
      @include media(">=large"){
        margin-left: $marginLeftRightDesktop;
        margin-right: $marginLeftRightDesktop;
      }
    }

    .figure--padded{
      margin-left: $marginLeftRight;
      margin-right: $marginLeftRight;
      @include media(">=large"){
        margin-left: $marginLeftRightDesktop;
        margin-right: 0;
      }
    }

    .block--content__quote{
      margin-left: 0;
      padding: calc(#{$marginLeftRight} * 2) $marginLeftRight;
      @include media(">=large"){
        padding: $marginLeftRight $marginLeftRight;
        padding-right: $marginLeftRightDesktop;
        margin-left: $marginLeftRightDesktop;
        margin-top: 10rem;
      }
      p{
        margin: 0;
      }
    }
    & > p, & > figure, & > ul, & > .block--schedule{
      margin-bottom: $padding;
    }
    figure + .accordion{
      margin-top: -$padding;
    }

    & > p + ul{
      margin-top: -$padding;
    }
    & > h4 + figure, & > h4 + .accordion{
      margin-top: $padding;
      @include media(">=large"){
        margin-top: $paddingDesktop;
      }
    }
    & > figure:last-of-type{
      margin-bottom: 0;
    }

    @include media(">=large"){
      & > p, & > figure, & > .block--schedule{
        margin-bottom: $paddingDesktop;
      }
      figure + .accordion{
        margin-top: -$paddingDesktop;
      }

      & > p + ul{
        margin-top: -$paddingDesktop;
      }
    }

  }
  .block--schedule{
    li{

      padding: 5rem 0 0;
      &:last-child{
        padding-bottom: 0;
      }
      &:first-child{
        padding-top: 0;
      }
      h4, p{
        margin: 0;
      }
      h4{
        margin-bottom: 3rem;
      }

      @include media(">=large"){
        border-top-style: solid;
        border-top-width: 1px;
        padding: $padding 0;
        display: flex;
        &:first-child{
          padding: 0 0 $padding;
          border: 0;
        }
        p{
          width: 60%;
        }
        h4{
          width: 40%;
          margin-bottom: 0;
          padding-right: 2rem;
        }
      }
    }
  }
}

/* @end */

</style>
